import {Product} from "../product/product";

/** Class that references the order receipt. */
export class Receipt {

    /** Receipt ID. */
    public id: number;

    /** Total order amount. */
    public grossValue: number;

    /** Total amount of products added. */
    public quantity: number;

    /** List of purchased products. */
    public products: Array<Product>;

    /** URL of the receipt pdf. */
    public receiptUrl: string;

    /** Date of completion of the order. */
    public lastChange: string;

    /** Date the order was created. */
    public createAt: string;

    constructor(
        id = NaN,
        grossValue = NaN,
        quantity = NaN,
        products: Product[] = [],
        receiptUrl= "",
        lastChange = "",
        createAt = ""
    ) {
        this.id = id;
        this.grossValue = grossValue;
        this.quantity = quantity;
        this.products = products;
        this.receiptUrl = receiptUrl;
        this.lastChange = lastChange;
        this.createAt = createAt;
    }
}